import classNames from 'classnames';
import linkpopByShopifyLogo from '../assets/linkpop-by-shopify-logo.svg';
import twitterIcon from '../assets/twitter-icon.svg';
import instagramIcon from '../assets/instagram-icon.svg';
import tiktokIcon from '../assets/tiktok-icon.svg';
import {Image} from '@shopify/hydrogen';
import {useI18n} from '../contexts/I18n.client';
import {Container} from './Container.client';
import {SocialMediaCircle} from './SocialMediaCircle.client';
import {Link} from '@shopify/hydrogen';
import {RoutePath} from 'utils/links';

export const Footer = () => {
  const {t} = useI18n();

  return (
    <Container
      className={classNames('flex', 'h-96', 'items-center', 'md:h-36')}
      backgroundGradientStart="light-green"
      backgroundGradientEnd="light-green"
    >
      <footer
        className={classNames(
          'flex',
          'w-full',
          'flex-col',
          'justify-between',
          'md:flex-row',
        )}
      >
        <div
          className={classNames(
            'flex',
            'w-full',
            'flex-row',
            'flex-wrap',
            'items-center',
            'justify-center',
            'gap-y-10',
            'gap-x-10',
            'xl:gap-x-20',
            'md:flex-nowrap',
          )}
        >
          <Link to={RoutePath.Home}>
            <Image
              className={classNames('h-7', 'md:h-8', 'hover:cursor-pointer')}
              src={linkpopByShopifyLogo}
              width={200}
              height={30}
              alt="logo of linkpop by shopify"
            />
          </Link>
          <div
            className={classNames(
              'flex',
              'w-full',
              'text-sm',
              'font-polysans',
              'flex-col',
              'items-center',
              'justify-between',
              'gap-y-8',
              'md:ml-auto',
              'md:w-auto',
              'md:gap-x-10',
              'md:flex-row',
              'lg:leading-10',
            )}
          >
            <a href={t('footerComponent.helpCenter.url')}>
              {t('footerComponent.helpCenter.title')}
            </a>
            <a href={t('footerComponent.termsOfService.url')}>
              {t('footerComponent.termsOfService.title')}
            </a>
            <a href={t('urls.privacyPolicy')}>
              {t('footerComponent.privacyPolicy')}
            </a>
          </div>
          <div
            className={classNames('flex', 'flex-row', 'gap-x-4', 'md:gap-x-6')}
          >
            <SocialMediaCircle
              icon={instagramIcon}
              href="https://www.instagram.com/shopify"
              platform="Instagram"
            />
            <SocialMediaCircle
              icon={twitterIcon}
              href="https://twitter.com/shopify"
              platform="Twitter"
            />
            <SocialMediaCircle
              icon={tiktokIcon}
              href="https://tiktok.com/@shopify"
              platform="TikTok"
            />
          </div>
        </div>
      </footer>
    </Container>
  );
};
